export default {
	UPDATE_ROUTES: "UPDATE_ROUTES"
};
